<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div
              class="col-md-6"
              style="padding: 70px 0px;"
            >
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('ep_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('ep_desc')}}</p>
            </div>
            <div
              class="col-md-6"
              style="text-align: center;"
            >
              <img
                src="../../assets/imgs/singin_man.png"
                class="pman"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;" >
          <div class="col-md-3">
             <app-company-sidebar :selectedItem="selectedItem"> </app-company-sidebar>
          </div>
          <div class="col-md-9">

            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('setting_menu_name')}}</span>
            </div>
            <div class="row mt-4">
                <div class="col-md-12 ml-3">
                    <h5>{{$t('setting_sub_had_name')}}</h5>
                </div>
                <div class="col-md-11 mt-4" style="padding-left:30px;">
                    <ul class="list-group">
                        <li class="list-group-item">
                            <div class="custom-controls-stacked d-block my-0">
                                <label class="custom-control material-switch">
                                    <span class="material-switch-control-description">{{$t('setting_item_text1')}}</span>
                                    <input v-model="get_favored_mail" @change="mailSetting()" type="checkbox" class="material-switch-control-input">
                                    <span class="material-switch-control-indicator"></span>
                                </label>
                            </div>
                        </li>
                        <li class="list-group-item">
                            <div class="custom-controls-stacked d-block my-0">
                                <label class="custom-control material-switch">
                                    <span class="material-switch-control-description">{{$t('setting_item_text2')}}</span>
                                    <input v-model="get_message_mail" type="checkbox" @change="mailSetting()" class="material-switch-control-input">
                                    <span class="material-switch-control-indicator"></span>
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-12 ml-3">
                    <h5>{{$t('communicate_title')}}</h5>
                </div>
                <div class="col-md-11 mt-4" style="padding-left:30px;">
                    <ul class="list-group">
                      <li class="list-group-item">
                          <div class="custom-controls-stacked d-block my-0">
                              <label class="custom-control material-switch">
                                  <span class="material-switch-control-description">{{$t('communicate_sub_heading')}}</span>
                                  <input v-model="want_to_talk_casually" @change="mailSetting()" type="checkbox" class="material-switch-control-input">
                                  <span class="material-switch-control-indicator"></span>
                              </label>
                          </div>
                      </li>

                    </ul>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import companySidebar from "./company_sidebar";
import { EventBus } from "../../main.js";

export default {
  data() {
    return {
      selectedItem: 72,
      loading: false,
      get_favored_mail: true,
      get_message_mail: true,
      want_to_talk_casually : false,
      lan: "jp"
    };
  },
components: {
    appCompanySidebar: companySidebar
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      if (data.get_favored_mail == 1 ){
          this.get_favored_mail = true
      }
      else{
          this.get_favored_mail = false
      }
      if (data.get_message_mail == 1) {
          this.get_message_mail = true;
      } else {
          this.get_message_mail = false
      }
      if (data.want_to_talk_casually) {
        this.want_to_talk_casually = data.want_to_talk_casually;
      }
  },
  mounted() {
    this.doCenter();
    EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  computed: {
    onResize(event) {
      this.doCenter();
    }
  },
  methods: {
    mailSetting() {
        this.loading = true;
        var token = localStorage.getItem("token");

        const formData = {
            get_favored_mail: this.get_favored_mail,
            get_message_mail: this.get_message_mail,
            want_to_talk_casually: this.want_to_talk_casually
        };
        axios
            .post("/company-user-settings?token="+token, formData ,{
            headers: { "X-localization": localStorage.getItem("lan") }
            })
            .then(res => {
            if (!res.data.result) {
                if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
                }
                this.loading = false;
            } else {
                this.loading = false;
                this.get_favored_mail = res.data.get_favored_mail;
                this.get_message_mail = res.data.get_message_mail;
                this.want_to_talk_casually = res.data.want_to_talk_casually;
                var user = JSON.parse(localStorage.getItem("user"))
                user.get_favored_mail = this.get_favored_mail;
                user.get_message_mail = this.get_message_mail;
                user.want_to_talk_casually = this.want_to_talk_casually;
                localStorage.setItem("user", JSON.stringify(user));
            }
            })
            .catch(error => console.log(error));
    },
    doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $("#total").css("font-size", "1rem");
        $("#technical").css("font-size", "1rem");
        $("#management").css("font-size", "1rem");
        $("#business").css("font-size", "1rem");
        txtwidth = [10.44, 20.88, 31.3];
        txtheight = 40;
      } else {
        $("#total").css("font-size", "1.5rem");
        $("#technical").css("font-size", "1.5rem");
        $("#management").css("font-size", "1.5rem");
        $("#business").css("font-size", "1.5rem");
        txtwidth = [15.66, 31.3, 46.95];
        txtheight = 28;
      }
    }
  }
};
</script>

<style scoped>
.custom-control.material-switch {
  --color: #3d7dd8;
  padding-left: 0;
}
.custom-control.material-switch .material-switch-control-input {
  display: none;
}
.custom-control.material-switch .material-switch-control-input:checked ~ .material-switch-control-indicator::after {
  background-color: var(--color);
  left: 17px;
}
.custom-control.material-switch .material-switch-control-indicator {
  display: block;
  position: relative;
  margin: 0 10px;
  top: 4px;
  float: right;
  width: 32px;
  height: 16px;
  background: #ddd;
  border-radius: 16px;
  transition: .3s;
}
.custom-control.material-switch .material-switch-control-indicator::after {
  content: '';
  display: block;
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  transition: .3s;
  top: -1px;
  left: -1px;
  background: #fdfdfd;
  box-shadow: 0 2px 10px #aaa;
}
.skillUpdate {
  padding-top: 10px;
  padding-bottom: 20px;
}

.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer2 {
  border: 2px solid #3d7dd8;
  font-size: 0.7rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #3d7dd8;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 10px;
}

.sub-layer2 {
  width: fit-content;
  background-color: #3d7dd8;
  font-size: 0.7rem;
  text-align: center;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #fff;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 10px;
  border-radius: 50px;
  display: block;
}


.pman {
  width: 120px;
  margin-top: 70px;
}

.slide_options {
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
  padding-left: 15px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 35px;
  max-width: 200px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  height: 50px;
  margin-bottom: 0.1rem;
}
.cline {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.statusnum {
  top: 55%;
  font-weight: bold;
  font-size: 3rem !important;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.custom-wrapper {
  /* width: 423px; */
  max-height: 250px;
  overflow: auto;
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }
}
</style>
